/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */

import React from 'react';
import RefreshIcon from '@material-ui/icons/Refresh';
import Dialog from '@material-ui/core/Dialog';
import { AppContext } from '../App';
import { ListItem, Button, DialogTitle, DialogContent, DialogActions, DialogContentText, ListItemIcon, ListItemText} from '@material-ui/core';
import { AppSettings } from '../model/AppSettings';
import * as ShortcutManager from '../model/ShortcutManager';

export interface ResetDuelToolItemProps {
    resetDuel: Function
}

export const ResetDuelToolItem = (props: ResetDuelToolItemProps) => {
    const settings = React.useContext<AppSettings>(AppContext);
    const resetDuelAudio = new Audio("/audio/free-start.mp3");
    const [open, setOpen] = React.useState<boolean>(false);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleReset = () => {
        resetDuelAudio.play();
        props.resetDuel(true);
        setOpen(false);
    }

    resetDuelAudio.volume = settings.volume / 100;

    ShortcutManager.register('r', () => {
        setOpen(!open);
    });

    return (
        <React.Fragment>
            <ListItem button onClick={handleOpen}>
                <ListItemIcon>
                    <RefreshIcon />
                </ListItemIcon>
                <ListItemText primary={"Reset Duel"} />
            </ListItem>
            <Dialog aria-labelledby="clear-current-battle-title"
                    aria-describedby="clear-current-battle-description"
                    keepMounted
                    open={open}
                    onClose={handleClose}>
                <DialogTitle id="clear-current-battle-title">Reset Game</DialogTitle>
                <DialogContent dividers>
                    <DialogContentText id="clear-current-battle-description">
                        Are you sure you want to reset the current duel? Life points, damage history, and wins will be reset.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={handleClose}>No</Button>
                    <Button color="secondary" onClick={handleReset}>Yes</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
